<template>
  <footer class="footer">
    <div class="container">
      <nav></nav>
      <div class="copyright text-center">
        &copy; {{ new Date().getFullYear() }}
        <a href="https://www.alandasilva.com.ar" target="_blank">Alan Da Silva</a>
      </div>
    </div>
  </footer>
</template>
<script>
export default {};
</script>
<style></style>
